import { Modal } from '@iheartjane/reefer';
import { useEffect } from 'react';

import type { CompareProduct } from './compareProvider';
import { useCompare } from './compareProvider';
import { CompareTable } from './compareTable';

import styles from './compareModal.module.css';

interface CompareModalProps {
  addToCartLabel?: string;
  /** See {@link CompareTable} — appends the in-bag count to each add button. */
  getCountInCart?: (productId: number) => number;
  isMobile: boolean;
}

export const CompareModal = ({
  addToCartLabel,
  getCountInCart,
  isMobile,
}: CompareModalProps) => {
  const {
    isModalOpen,
    closeModal,
    dismissModal,
    products,
    productCount,
    removeProduct,
    triggerAddToCart,
    triggerView,
  } = useCompare();

  useEffect(() => {
    if (isModalOpen && productCount < 2) {
      closeModal();
    }
  }, [isModalOpen, productCount, closeModal]);

  const handleProductClick = (product: CompareProduct) => {
    closeModal();
    triggerView(product.id);
  };

  const handleAddToCart = (product: CompareProduct) => {
    triggerAddToCart(product.id);
  };

  return (
    <Modal
      open={isModalOpen}
      onRequestClose={dismissModal}
      variant={isMobile ? 'full-screen' : 'flex'}
      className={isMobile ? undefined : styles['compareModal']}
      background="grays-white"
      overlayClose
      contentLabel="Compare products"
    >
      <Modal.Header title="Compare products" />
      <Modal.Content padding={false} className={styles['modalScrollContainer']}>
        <CompareTable
          products={products}
          onRemove={removeProduct}
          onProductClick={handleProductClick}
          onAddToCart={handleAddToCart}
          addToCartLabel={addToCartLabel}
          getCountInCart={getCountInCart}
        />
      </Modal.Content>
    </Modal>
  );
};
